import { useAuth } from "@clerk/clerk-react";
import { ConvexReactClient } from "convex/react";
import { ConvexProviderWithClerk } from "convex/react-clerk";

const convex = new ConvexReactClient(import.meta.env.VITE_CONVEX_URL!);

export function preferConvexJwtTemplate<T extends { sessionClaims: unknown }>(
  auth: T,
): Omit<T, "sessionClaims"> & { sessionClaims: undefined } {
  // Clerk's instance session token also has aud=convex, but it does not carry
  // the verified-email claims used for Member Portal authorization. Hiding
  // those session claims makes ConvexProviderWithClerk request the named
  // `convex` JWT template instead.
  return { ...auth, sessionClaims: undefined };
}

function useConvexTemplateAuth() {
  return preferConvexJwtTemplate(useAuth());
}

export function ConvexClientProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <ConvexProviderWithClerk client={convex} useAuth={useConvexTemplateAuth}>
      {children}
    </ConvexProviderWithClerk>
  );
}
